import { keepPreviousData, queryOptions } from "@tanstack/react-query";
import { type ColumnFiltersState, type PaginationState, type SortingState } from "@tanstack/react-table";
import { useAppSelector } from "../../../redux/hooks";
import { apiClient } from "../../../zodios/client";
import { clientToServerSorting } from "../../../components/table/utils";
import { useDates } from "../../../dates/DatesContext";

type Params = {
  pagination: PaginationState;
  sorting: SortingState;
  filters?: ColumnFiltersState;
  search?: string;
};

export const useGetV4AdvReportByAd = () => {
  const marketPlace = useAppSelector((state) => state.marketPlace.marketPlace);
  const { start, end, preStart, preEnd } = useDates();

  return (params: Params) => {
    const cursor = params.pagination.pageIndex * params.pagination.pageSize || undefined;
    const search = params.search ? params.search.split(",") : [];
    return queryOptions({
      queryKey: [{ entity: "V4AdvReportByAd", marketPlace, params, dates: { start, end, preStart, preEnd } }],
      queryFn: async () =>
        await apiClient.getV4AdvReportByAd({
          queries: {
            marketplace: marketPlace,
            start_date: start.format("YYYY-MM-DD"),
            end_date: end.format("YYYY-MM-DD"),
            start_date_previous: preStart.format("YYYY-MM-DD"),
            end_date_previous: preEnd.format("YYYY-MM-DD"),
            // TODO fix typing
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            filters: params.filters as any,
            cursor,
            limit: params.pagination.pageSize,
            ordering: clientToServerSorting(params.sorting),
            search: search,
          },
        }),
      placeholderData: keepPreviousData,
    });
  };
};

export type AdvertisementQueryV4Row = Awaited<ReturnType<typeof apiClient.getV4AdvReportByAd>>["data"][number];
